import { createFileRoute } from '@tanstack/react-router'
import Subscribers from 'Integration/components/webhooks/subscribers/Subscribers'

export const Route = createFileRoute('/integrations/_webhooks/webhook/subscribers')({
    component: Subscribers,
})
